import React from 'react'
import { classNameBuilder } from '@/helpers'

type BadgeColorType = 'blue' | 'yellow' | 'gray' | 'red'
type BadgeSizeType = '24' | '16'

export interface BadgeProps {
  color?: BadgeColorType
  size?: BadgeSizeType
  className?: string
  children?: React.ReactNode | React.ReactNode[]
}
export const Badge: React.FC<BadgeProps> = ({
  color = 'gray',
  size = '24',
  className,
  children
}) => {
  return (
    <span
      className={classNameBuilder(
        'flex shrink-0 items-center rounded-full',
        intentMap[color],
        sizeMap[size],
        className
      )}
    >
      {children}
    </span>
  )
}

export default Badge

const intentMap: Record<BadgeColorType, string> = {
  gray: 'bg-gray-50 text-gray-500',
  red: 'bg-red-100 text-red-500',
  blue: 'bg-[#03A0F91A] text-[#03A0F9]',
  yellow: 'bg-[#FFF9C4] text-[#F57F17]'
}

const sizeMap: Record<BadgeSizeType, string> = {
  '16': 'px-2 h-4 text-xs',
  '24': 'px-4 h-6 text-sm'
}
